import * as z from 'zod';
import { createSelectSchema } from 'drizzle-zod';
import type { QueryResult } from '@iichi/schema-database/types/event';
import * as schema from '@iichi/schema-database';

export const eventSchema = createSelectSchema(schema.event).extend({
  createdAt: z.coerce.date(),
  endAt: z.coerce.date().nullable(),
  slug: z.string().regex(/^[A-Z][0-9]{7}$/),
  startAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  url: z.url(),
});

export type Event = z.infer<typeof eventSchema>;

export const serialize = (data: QueryResult): Event => {
  return eventSchema.parse(data);
};
